import * as actionTypes from '../actionTypes'

export const defaultLocale = 'en-US'

const i18n = (state = {
	isLoading: false,
	isLoaded: false,
	locale: defaultLocale,
	messages: null
}, action) => {
	switch (action.type) {
		case actionTypes.I18N_LOADING_STARTED:
			return {
				...state,
				isLoading: true,
				isLoaded: false
			}
		case actionTypes.I18N_LOADING_COMPLETED:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				messages: action.messages,
				locale: action.locale || defaultLocale
			}
		default:
			return state
	}
}

export default i18n


// WEBPACK FOOTER //
// ./src/reducers/i18n.js